/**
 * Exporta a XLSX el Reporte de Auditoría.
 * Reutiliza la librería `xlsx` (SheetJS), ya incluida en el proyecto.
 *
 * @param {Object} params
 * @param {Array}  params.resultados — filas del reporte (shape del backend)
 * @param {Object} params.contexto  — filtros activos { nombre_usuario, modulo, pantalla, fecha_desde, fecha_hasta }
 */
import * as XLSX from 'xlsx';
import { resolverNombrePantalla } from './auditoriaLabels';

const COLUMNAS = [
  '#',
  'Usuario Creación',
  'Fecha Creación',
  'Usuario Modificación',
  'Fecha Modificación',
  'Módulo',
  'Pantalla',
  'Registro Modificado',
];

function fechaArchivo() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(d.getHours())}${pad(d.getMinutes())}`;
}

function formatFecha(str) {
  if (!str || str === 'N/A') return str || '';
  try {
    const d = new Date(str.replace(' ', 'T'));
    if (isNaN(d.getTime())) return str;
    return d.toLocaleString('es-MX', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  } catch {
    return str;
  }
}

export function exportReporteAuditoriaXLS({ resultados = [], contexto = {} } = {}) {
  const {
    nombre_usuario = '',
    modulo = '',
    pantalla = '',
    fecha_desde = '',
    fecha_hasta = '',
  } = contexto;

  const aoa = [
    ['REPORTE DE AUDITORÍA DEL SISTEMA'],
    nombre_usuario ? [`Usuario: ${nombre_usuario}`] : ['Usuario: Todos'],
    modulo ? [`Módulo: ${modulo}`] : ['Módulo: Todos'],
    pantalla ? [`Pantalla: ${pantalla}`] : ['Pantalla: Todas'],
    fecha_desde || fecha_hasta
      ? [`Período: ${fecha_desde || 'sin límite'} al ${fecha_hasta || 'sin límite'}`]
      : ['Período: Sin restricción de fechas'],
    [`Generado: ${new Date().toLocaleString('es-MX')}`],
    [`Total de registros: ${resultados.length}`],
    [],
    COLUMNAS,
  ];

  resultados.forEach((r, idx) => {
    aoa.push([
      idx + 1,
      r.usuario_creacion || 'N/A',
      r.fecha_creacion ? formatFecha(r.fecha_creacion) : '',
      r.usuario_modificacion || 'N/A',
      r.fecha_modificacion ? formatFecha(r.fecha_modificacion) : '',
      r.modulo || '',
      resolverNombrePantalla(r.pantalla),
      r.descripcion_registro || '',
    ]);
  });

  const ws = XLSX.utils.aoa_to_sheet(aoa);
  ws['!cols'] = [
    { wch: 5 },
    { wch: 32 },
    { wch: 22 },
    { wch: 32 },
    { wch: 22 },
    { wch: 35 },
    { wch: 40 },
  ];
  ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: COLUMNAS.length - 1 } }];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Auditoría');
  XLSX.writeFile(wb, `reporte_auditoria_${fechaArchivo()}.xlsx`);
}

export default exportReporteAuditoriaXLS;
